module.exports = __webpack_public_path__ + "static/stacking_plan-e0ece93ee4200b306b4cb2300113ca4d.png";